<template>
	<v-card> 
		<v-card-title >
			<h2>Grupy docelowe</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-btn class="ml-3" primary @click="addBeneficiaryVisible = true">Dodaj grupę docelową</v-btn>

		<v-data-table
			hide-actions
			:headers="headers"
			:items="beneficiaries">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.name }}</td>
				<td>
					<v-icon small
						@click="editBeneficiary(props.item)"
						class="mr-2">
						edit
					</v-icon>
					<v-icon small
						@click="moveUpwards(props.item)"
						class="mr-2">
						arrow_upward
					</v-icon>
					<v-icon small
						@click="moveDownwards(props.item)"
						class="mr-2">
						arrow_downward
					</v-icon>
					<v-icon small
						color= "lightred"
						@click="deleteBeneficiary(props.item)"
						class="mr-2">
						delete
					</v-icon>
				</td>
			</template>
		</v-data-table>

		<egranty-input-field-popup
			:is-open.sync="addBeneficiaryVisible"
			:title="'Dodaj grupę docelową'"
			:label="'Nazwa'"
			long
			@save="addBeneficiary"
		></egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="editBeneficiaryVisible"
			:title="'Edytuj grupę docelową'"
			:label="'Nazwa'"
			long
			:default-value="edited.name"
			@save="renameBeneficiary"
		></egranty-input-field-popup>
	</v-card>
</template>

<script>
	import {Beneficiary} from "../../../../api/generated/Beneficiary";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "ContestBeneficiariesTable",
		components: {EgrantyInputFieldPopup},

		methods: {
			getContestId () {
				return this.$route.params.id;
			},

			editBeneficiary (item) {
				this.edited.id = item.id;
				this.edited.name = item.name;
				this.editBeneficiaryVisible = true;
			},

			deleteBeneficiary (item) {
				if(this.announced && this.beneficiaries && this.beneficiaries.length == 1){
					this.$messagesBus.$emit("error", "Nie można usunąć ostatniej grupy docelowej, gdy konkurs został już opublikowany.");
					return;
				}
				Beneficiary.deleteBeneficiary(
					this,
					this.getContestId(),
					item.id,
					successResponse => {
						this.refresh();
						this.$messagesBus.$emit("success", "Grupa została pomyślnie usunięta", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
					}
				);
			},

			addBeneficiary (name) {
				Beneficiary.putBeneficiary(
					this,
					this.getContestId(),
					name,
					successResponse => {
						this.refresh();
						this.addBeneficiaryVisible = false;
						this.$messagesBus.$emit("success", "Grupa została pomyślnie dodana", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się dodać grupy", errorResponse);
					}
				);
			},

			renameBeneficiary (name) {
				Beneficiary.put(this, this.edited.id, name, successResponse => {
						this.beneficiaries.find(b => b.id === this.edited.id).name = name;
						this.$messagesBus.$emit("success", "Nazwa grupy została pomyślnie zmieniona", successResponse);
						this.editBeneficiaryVisible = false;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zmienić nazwy grupy", errorResponse);
					});
			},

			moveUpwards (item) {
				Beneficiary.putUpwards(this, this.getContestId(), item.id, () => {
					this.refresh();
				});
			},

			moveDownwards (item) {
				Beneficiary.putDownwards(this, this.getContestId(), item.id, () => {
					this.refresh();
				});
			},

			refresh () {
				Beneficiary.getAllBeneficiaries(
					this,
					this.getContestId(),
					response => {
						this.beneficiaries = response;
					},
				);
			},
		},

		mounted () {
			this.refresh();
		},

		watch: {
			editBeneficiaryVisible (val) {
				if (!val) {
					this.edited.id = null;
					this.edited.name = '';
				}
			},
		},

		data () {

			return {

				addBeneficiaryVisible: false,

				editBeneficiaryVisible: false,

				edited: {
					id: null,
					name: ''
				},

				beneficiaries: [],

				headers: [
					{text: "Nazwa", value: "name", sortable: false},
					{text: "Akcje", value: "actions", sortable: false}
				],

			};
		},

		props: {
			announced: undefined
		}
	};
</script>

<style scoped>
	.v-card__title {
		margin-top: 20px !important;
	}
	
</style>
